export const DOCUMENTS_AREA = 'DOCUMENTS' as const;
export const REGISTRATION_PART = 'REGISTRATION' as const;
export const CERTIFICATE_PART = 'COC' as const;
export const SUPPORTING_DOCUMENTS_PART = 'ELECTRIC_VEHICLE' as const;
